import type { JobApplicationStatus } from '@mds/shared/types/job-application';

/** How an application's status reads, and the classes to draw it in. */

const LABELS: Record<JobApplicationStatus, string> = {
  submitted: 'New',
  in_review: 'In review',
  shortlisted: 'Shortlisted',
  hired: 'Hired',
  rejected: 'Rejected',
};

const TONES: Record<JobApplicationStatus, string> = {
  submitted: 'border-warn-edge bg-warn-wash text-warn-text',
  in_review: 'border-hairline bg-surface text-ink-secondary',
  shortlisted: 'border-brand-edge/35 bg-brand-wash text-brand-strong',
  hired: 'border-mint/35 bg-mint-wash text-mint-deep',
  rejected: 'border-hairline bg-raised text-ink-muted',
};

export const applicationStatusLabel = (status: JobApplicationStatus) => LABELS[status];
export const applicationStatusTone = (status: JobApplicationStatus) => TONES[status];

/** Hired and rejected are final; everything before them can still be rejected. */
export const isOpenApplication = (status: JobApplicationStatus) =>
  status !== 'hired' && status !== 'rejected';

/** The one forward step from each open status, and what its button says. */
export const NEXT_STEP: Partial<
  Record<JobApplicationStatus, { to: JobApplicationStatus; label: string }>
> = {
  submitted: { to: 'in_review', label: 'Start review' },
  in_review: { to: 'shortlisted', label: 'Shortlist' },
  shortlisted: { to: 'hired', label: 'Mark as hired' },
};

export const fileSize = (bytes: number) =>
  bytes < 1_000_000 ? `${Math.round(bytes / 1000)} KB` : `${(bytes / 1_000_000).toFixed(1)} MB`;

/** `+96171123456` → `+961 71 123 456`, the way the form shows it. */
export const phoneLabel = (e164: string) =>
  e164.startsWith('+961') ? `+961 ${e164.slice(4, 6)} ${e164.slice(6, 9)} ${e164.slice(9)}` : e164;
